import { useMemo, useState } from 'react';
import { debounce } from '@saviynt/common';

const DASHBOARD_SEARCH_DEBOUNCE_MS = 2000;
const MIN_DEBOUNCE_CHARS = 2;
const ENABLE_DEBOUNCE_SEARCH = false;

// TODO: add types to ui-core common package to remove eslint disables

// eslint-disable-next-line import/prefer-default-export
export const useSearchHandlers = () => {
  const [searchInput, setSearchInput] = useState('');
  const [searchValue, setSearchValue] = useState('');

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const debouncedSearch = useMemo(
    () =>
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
      debounce((searchTerm: string) => {
        setSearchValue(searchTerm);
      }, DASHBOARD_SEARCH_DEBOUNCE_MS),
    []
  );

  const handleSearchInputChange = (newValue: string) => {
    setSearchInput(newValue);

    // Auto-search after debounce (if enough characters)
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (ENABLE_DEBOUNCE_SEARCH && newValue.length >= MIN_DEBOUNCE_CHARS) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      debouncedSearch(newValue);
    } else if (newValue.length === 0) {
      // Clear search immediately when input is empty

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
      debouncedSearch.cancel();
      setSearchValue('');
    }
  };

  const handleSearchKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
      debouncedSearch.cancel(); // Cancel pending debounced search
      setSearchValue(searchInput); // Immediate search
    }
  };

  const handleSearchClear = () => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    debouncedSearch.cancel(); // Cancel pending search
    setSearchValue(''); // Immediate clear
  };

  return {
    searchInput,
    searchValue,
    handleSearchInputChange,
    handleSearchKeyDown,
    handleSearchClear,
  };
};
